import grispiApi from '../../apis/grispiApi';
import {
    CreateOrganizationPostData,
    CreateOrganizationReturnData,
    Organization,
    UpdateOrganizationPostData
} from '../../model/types';

export const createOrganization = async (
    createOrganizationPostData: CreateOrganizationPostData
): Promise<CreateOrganizationReturnData> => {
    const response = await grispiApi.post('/organizations', createOrganizationPostData);
    return response.data;
};

export const updateOrganization = async (
    updateOrganizationPostData: UpdateOrganizationPostData
): Promise<Organization> => {
    const { organizationId, ...rest } = updateOrganizationPostData;
    const response = await grispiApi.put(`/organizations/${organizationId}`, rest);
    return response.data;
};

export const deleteOrganization = async (organizationId: number): Promise<void> => {
    await grispiApi.delete(`/organizations/${organizationId}`);
};

export const addUsersToOrganization = async (organizationId: number, postData: { users: number[] }): Promise<void> => {
    await grispiApi.put(`/organizations/${organizationId}/users`, postData);
};
